import * as CombosReducer from './list';
import * as ComboDetails from './edit';

const Reducers = {
  ...CombosReducer,
  ...ComboDetails,
};

export default Reducers;
